import React from 'react'
import { Card, Row, Container, CardHeader, Col, CardBody, CardTitle, NavItem, TabContent, NavLink, Nav, CardText, Button,    Table,
  FormGroup,
  FormText,
  Form,
  Input,
  Label,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,TabPane, ListGroup, ListGroupItem } from 'reactstrap'
  import { Link, useNavigate } from "react-router-dom";


const Teaching = () => {
  return (
    <div>
         <div style={{ overflowX: 'auto' }}>
                      <Table  hover>
                        <thead>
                          <tr style={{ background: "#F6F9FC" }}>
                            <th>S.NO</th>
                            <th>School/Institute Name</th>
                            <th>Your Designation</th>
                            <th>Duration</th>
                            <th>Class Tought</th>
                            <th>Board Tought</th>
                            <th>Subject Tought</th>
                            <th>Experience Deatils</th>
                            {/* <th>Action</th> */}
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>1</td>
                            <td>Cormal Convent High School	</td>
                            <td>Teaching</td>
                            <td>1 Year</td>
                            <td>10th</td>
                            <td>CBSC</td>
                            <td>Maths</td>
                            <td>It involves working with students, planning and delivering lesson</td>
          
                          </tr>
                          <tr>
                            <td>2</td>
                            <td>Cormal Convent High School	</td>
                            <td>Teaching</td>
                            <td>1 Year</td>
                            <td>10th</td>
                            <td>CBSC</td>
                            <td>Maths</td>
                            <td>It involves working with students, planning and delivering lesson</td>
                         
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                    <br />
                 
    </div>
  )
}

export default Teaching
